import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import classNames from 'classnames/bind';
import { IMarks } from 'list/international/types';
import { Range } from 'rc-slider';
import { useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const style = {
  mark_min: {
    top: '3px',
    marginTop: '4px',
    fontSize: '13px',
    color: '#8f8f8f',
    wordBreak: 'keep-all',
    transform: 'none',
    msTransform: 'none',
  },
  mark_max: {
    top: '3px',
    left: 'auto',
    right: '0',
    marginTop: '4px',
    fontSize: '13px',
    color: '#8f8f8f',
    wordBreak: 'keep-all',
    transform: 'none',
    msTransform: 'none',
  },
  label_name: {
    marginRight: '4px',
    color: '#666666',
  },
  label_value: {
    color: '#5398f5',
  },
  slider: {
    width: 'auto',
    margin: '20px 5px 19px',
    height: '21px',
    padding: '10px 0 9px',
  },
  track: {
    height: '2px',
    backgroundColor: '#5398f5',
  },
  rail: {
    height: '2px',
    backgroundColor: '#d6dde2',
  },
  handle: {
    marginTop: '-10px',
    width: '21px',
    height: '21px',
    border: 'none',
    borderRadius: '15px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.15)',
    backgroundColor: '#ffffff',
  },
  dot: {
    display: 'none',
  },
};

export enum PriceUnit {
  'THOUSAND' = 1000,
  'TENTHOUSAND' = 10000,
}

export enum CountingUnit {
  'SINGLE' = '성인 1인',
  'ALL' = '승객 총액',
}

const unitDescMap = new Map([
  [PriceUnit.THOUSAND, '천'],
  [PriceUnit.TENTHOUSAND, '만'],
]);

export interface IRange {
  min?: number;
  max?: number;
}

interface IProps {
  areaCode: string;
  min: number;
  max: number;
  selectedRange?: IRange;
  onAfterChange: (value: number[]) => void;
  unit?: PriceUnit;
  countingUnit?: CountingUnit;
}

function PriceRangeFilter({
  areaCode,
  min,
  max,
  onAfterChange,
  unit = PriceUnit.TENTHOUSAND,
  countingUnit = CountingUnit.SINGLE,
  selectedRange: propsSelectedRange,
}: IProps) {
  const minPrice = Math.floor(min / unit) * unit;
  const maxPrice = Math.ceil(max / unit) * unit;

  const selectedRange = {
    min: propsSelectedRange?.min || minPrice,
    max: propsSelectedRange?.max || maxPrice,
  };

  const [range, setRange] = useState([selectedRange.min, selectedRange.max]);
  const unitDesc = unitDescMap.get(unit) || '';
  const marks: IMarks = {
    [minPrice]: {
      style: style.mark_min,
      label: withPriceSeperator(minPrice / unit) + unitDesc,
    },
    [maxPrice]: {
      style: style.mark_max,
      label: withPriceSeperator(maxPrice / unit) + unitDesc,
    },
  };
  const setChangedValue = (value: number[]) => {
    onAfterChange(value);
  };
  return (
    <div
      className={cx('PriceRangeFilter')}
      data-event-nlog="click"
      data-event-area-code={`${areaCode}.pricerange`}
    >
      <i className={cx('base')}>{countingUnit} 기준 요금</i>
      <span className={cx('current', 'as_price')}>
        <b className={cx('value')}>
          {range
            .map(
              (value, index) =>
                withPriceSeperator(
                  index === 0
                    ? Math.floor(value / unit)
                    : Math.ceil(value / unit),
                ) + unitDesc,
            )
            .join(' - ')}
        </b>
      </span>
      <Range
        min={minPrice}
        max={maxPrice}
        value={range}
        step={unit}
        tabIndex={[1, 2]}
        allowCross={false}
        onChange={val => setRange(val)}
        onAfterChange={setChangedValue}
        marks={marks}
        trackStyle={[style.track]}
        railStyle={style.rail}
        handleStyle={[style.handle, style.handle]}
        dotStyle={style.dot}
        style={style.slider}
      />
    </div>
  );
}

export default PriceRangeFilter;
